/**
 *  All api related to Support Ticket
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function createSupportTicket(support_ticket) {
  const payload = {
    data: {
      support_ticket
    },
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createSupportTicket',
    () => source.cancel('createSupportTicket: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `support_tickets`,
      method: 'post',
      data: payload,
      cancelToken: source.token,
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      supportTicket: data.supportTicket
    }))
}
